import * as React from 'react';
import { useFeatureToggles, useDispatch } from '@grandvisionhq/state';
import { startPrescriptionGlassesConfiguration } from '../../state/actions.js';
import { convertCmsRxEntries } from '../../utils/convert-cms-rx-entries.js';
import { usePrescriptionTypes } from '../hooks/use-prescription-types.js';

const RxGlassesConfiguratorContext = /*#__PURE__*/ React.createContext({});
const useRxGlassesConfiguratorContext = ()=>React.useContext(RxGlassesConfiguratorContext)
;
const RxGlassesConfiguratorProvider = ({ children , opticianForm , configuratorDocument , frame , frameSku , formatProductUrl , id , usps , routes ,  })=>{
    const { isPrescriptionGlassesConfiguratorValidationStepEnabled: isExtraValidationStepEnabled  } = useFeatureToggles();
    const prescriptionTypesOrder = usePrescriptionTypes();
    let preselectedPrescriptionEntry = prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder[0];
    const { entryTypes  } = (configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.prescriptionStep) || {};
    const rxEntryTypes = convertCmsRxEntries(entryTypes);
    if (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes[0]) {
        preselectedPrescriptionEntry = rxEntryTypes[0].key;
    }
    const value = {
        opticianForm,
        configuratorDocument,
        isExtraValidationStepEnabled,
        id
    };
    const dispatch = useDispatch();
    React.useEffect(()=>{
        dispatch(startPrescriptionGlassesConfiguration({
            frame,
            frameSku,
            formatProductUrl,
            isExtraValidationStepEnabled,
            preselectedPrescriptionEntry,
            rxEntryTypes,
            usps,
            routes
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(RxGlassesConfiguratorContext.Provider, {
        value: value
    }, children);
};

export { RxGlassesConfiguratorContext, RxGlassesConfiguratorProvider, useRxGlassesConfiguratorContext };
//# sourceMappingURL=RxGlassesConfiguratorContext.js.map
